import { Link as RouterLink } from 'inferno-router';
import pathToRegexp from 'path-to-regexp';

const Link = ({ params, to, ...rest }) =>
  <RouterLink to={pathToRegexp.compile(to)(params)} {...rest} />;

export default Link;
